import { Alert, AlertTitle } from '@/components/core/alert';
import { Button } from '@/components/core/button';
import { Progress } from '@/components/core/progress';
import { RunnerResultsTable } from '@/components/data-importer/runner-results-table';
import { formatShortInt } from '@/shared/helpers';

import {
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../core/dialog';
import { CreatedRecord, ErrorRecord, TemplateKey } from './types';

type Props = {
  template: TemplateKey;
  running: boolean;
  totalCount?: number;
  completedCount?: number;
  createdRecords?: CreatedRecord[];
  errorRecords?: ErrorRecord[];
};

const titleByKey: Record<TemplateKey, string> = {
  [TemplateKey.SKUS]: 'Import SKUs',
  [TemplateKey.ASNS]: 'Import ASNs',
  [TemplateKey.ORDERS]: 'Import Orders',
};

export function RunnerDialogContent({
  template,
  running,
  completedCount,
  totalCount,
  createdRecords,
  errorRecords,
}: Props) {
  return (
    <DialogContent className="h-full w-full sm:max-w-[calc(100%-2rem)]">
      <DialogHeader>
        <DialogTitle>{titleByKey[template]}</DialogTitle>
      </DialogHeader>
      <DialogBody>
        {running && (
          <Alert variant="warning">
            <AlertTitle>
              Be sure not to navigate away from this page while the import is running, otherwise it
              will cease.
            </AlertTitle>
          </Alert>
        )}
        {totalCount !== undefined && (
          <div className="flex items-center gap-2">
            <Progress className="w-full" value={((completedCount ?? 0) / totalCount) * 100} />
            <span>
              {formatShortInt(completedCount ?? 0)}/{formatShortInt(totalCount ?? 0)}
            </span>
          </div>
        )}
        <RunnerResultsTable
          template={template}
          created={createdRecords ?? []}
          errors={errorRecords ?? []}
        />
      </DialogBody>
      <DialogFooter>
        <DialogClose asChild>
          <Button>{running ? 'Close' : 'Done'}</Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
}
